import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuProductionStatusView } from "src/tenantCustomizations/tenants/mellano/views/luukku/production/MellanoLuukkuProductionStatusView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/productionStatus")({
	staticData: { title: "Tuotantotilanne", legacyViewKey: "mellanoLuukkuProductionStatusView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuProductionStatusView />;
}
